import { MuiThemeProvider } from '@inbody/core';
import '@inbody/core/fonts.css';
import { QueryProvider } from '@inbody/data';
import { AuthProvider } from '@inbody/keycloak';
import { GlobalStyles } from '@mui/material';

import './shared/lib/i18n/setup';
import { BrowserRouter } from './shared/lib/react-router';

function App() {
  return (
    <MuiThemeProvider>
      {/* 스크롤바·날짜 선택 창처럼 브라우저가 그리는 부분은 color-scheme 을 따른다.
          공용 테마는 MUI 색만 바꾸므로, 다크 모드도 브라우저에 알려 준다. */}
      <GlobalStyles
        styles={(theme) => ({ html: { colorScheme: theme.palette.mode } })}
      />
      <QueryProvider>
        <AuthProvider
          config={{
            clientId: 'd365-data-center',
            url: 'https://keycloak.weareinbody.com',
          }}
        >
          <BrowserRouter />
        </AuthProvider>
      </QueryProvider>
    </MuiThemeProvider>
  );
}

export default App;
